export enum BorrowerIncomeType {
  W2 = 'W2',
  W2SecondEmployer = 'W2_second_employer',
  W2ThirdEmployer = 'W2_third_employer',
  SelfEmployed = 'self_employed',
  VaDisability = 'va_disability',
  MilitaryPension = 'military_pension',
  EmployerPension = 'employer_pension',
  SocialSecurity = 'social_security',
  RentalIncome = 'rental_income',
  HomemakerUnemployed = 'homemaker_unemployed',
  Other = 'other',
  OtherDescription = 'other_description',
}
